import React from "react";
import axios from "axios";
import { Button, TextInput } from "@opendate-app/setlist";

import { useMarketingSettingsContext } from "../MarketingSettingsIndexContainer";
import SendDomainStatus from "./SendDomainStatus";
import EmailFromAddressInput from "./EmailFromAddressInput";
import RowKebabMenu from "./RowKebabMenu";
import SetupInstructions from "./SetupInstructions";
import TrackingDomainSection from "./TrackingDomainSection";
import { toastSuccess, toastError } from "../../../../shared/toastHelper";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  header: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  fields: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 16,
    maxWidth: 640,
  },
};

const SendDomainRow = ({
  sendDomain
}) => {
  const {
    csrfToken,
    team,
    venueOwnership,
    sendDomainModified,
    sendDomainCreated,
    updateSendDomain,
  } = useMarketingSettingsContext();
  const persistedSendDomain = !!sendDomain.id;
  const verifyDomain = (e) => {
    e.preventDefault();

    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post(`/teams/${team.id}/venue_ownerships/${venueOwnership.id}/send_domains/${sendDomain.id}/verify`)
      .then(({ data }) => {
        sendDomainModified(data);

        if (data.verified) {
          toastSuccess("Domain verified, you can now test the email from address.");
        } else {
          toastError("Domain verification failed, please wait a few minutes and try again.");
        }
      })
      .catch((_error) => {
        toastError("Domain verification failed");
      });
  };

  const createSendDomain = () => {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios.post(`/teams/${team.id}/venue_ownerships/${venueOwnership.id}/send_domains`, {
      send_domain: {
        domain: sendDomain.domain,
        from_address: sendDomain.from_address
      }
    })
      .then(({ data }) => {
        toastSuccess("Send domain added successfully");
        sendDomainCreated(venueOwnership, data);
      })
      .catch(({ response }) => {
        toastError(response.data.errors.join(", "));
      });
  };

  if (!persistedSendDomain) {
    return (
      <div style={styles.container}>
        <div style={styles.fields}>
          <TextInput
            label="Domain address"
            type="text"
            value={sendDomain.domain || ""}
            onChange={(e) => sendDomainModified({ ...sendDomain, domain: e.target.value })}
            placeholder="yourvenue.com"
          />
          <EmailFromAddressInput sendDomain={sendDomain} />
        </div>
        <div>
          <Button variant="primary" onClick={createSendDomain}>Add domain</Button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <SendDomainStatus sendDomain={sendDomain} />
        <div style={styles.actions}>
          <Button onClick={verifyDomain}>Verify domain</Button>
          {sendDomain.verified ? (
            <Button onClick={() => updateSendDomain(sendDomain)}>Update</Button>
          ) : null}
          <RowKebabMenu sendDomain={sendDomain} />
        </div>
      </div>
      {sendDomain.verified ? (
        <div style={styles.fields}>
          <TextInput
            label="Sender name"
            placeholder="Your Venue"
            type="text"
            value={sendDomain.name || ""}
            onChange={(e) => sendDomainModified({ ...sendDomain, name: e.target.value })}
          />
          <EmailFromAddressInput sendDomain={sendDomain} />
        </div>
      ) : null}
      <SetupInstructions sendDomain={sendDomain} />
      {sendDomain.verified ? <TrackingDomainSection sendDomain={sendDomain} /> : null}
    </div>
  );
};

export default SendDomainRow;
